import { round } from 'lodash';

const priceView = (currency, price) => (
  `${currency}${round(price, 2).toFixed(2)}`
);

export { priceView };
